import { render, staticRenderFns } from "./StatutoryBasis.vue?vue&type=template&id=7d2b6006&scoped=true"
import script from "./StatutoryBasis.vue?vue&type=script&lang=js"
export * from "./StatutoryBasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2b6006",
  null
  
)

export default component.exports